import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Grid is a component that exposes grid system props. See the `}<a parentName="p" {...{
        "href": "https://css-tricks.com/snippets/css/complete-guide-grid/"
      }}>{`CSS Tricks Complete Guide to Grid`}</a>{` to learn more about Grid Layout.`}</p>
    <h2>{`Deprecation`}</h2>
    <p>{`Use `}<a parentName="p" {...{
        "href": "/Box"
      }}>{`Box`}</a>{` instead.`}</p>
    <h3>{`Before`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated",
        "deprecated": true
      }}>{`<Grid gridTemplateColumns="repeat(2, auto)" gridGap={3}>
  <Box p={3} color="fg.onEmphasis" bg="accent.emphasis">
    1
  </Box>
  <Box p={3} color="fg.onEmphasis" bg="attention.emphasis">
    2
  </Box>
</Grid>
`}</code></pre>
    <h3>{`After`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated",
        "deprecated": true
      }}>{`<Box display="grid" gridTemplateColumns="repeat(2, auto)" gridGap={3}>
  <Box p={3} color="fg.onEmphasis" bg="accent.emphasis">
    1
  </Box>
  <Box p={3} color="fg.onEmphasis" bg="attention.emphasis">
    2
  </Box>
</Box>
`}</code></pre>
    <h2>{`Default example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated live",
        "deprecated": true,
        "live": true
      }}>{`<Grid gridTemplateColumns="repeat(2, auto)" gridGap={3}>
  <Box p={3} color="fg.onEmphasis" bg="accent.emphasis">
    1
  </Box>
  <Box p={3} color="fg.onEmphasis" bg="attention.emphasis">
    2
  </Box>
</Grid>
`}</code></pre>
    <h2>{`System props`}</h2>
    <p>{`Grid components get `}<inlineCode parentName="p">{`GRID`}</inlineCode>{`, `}<inlineCode parentName="p">{`COMMON`}</inlineCode>{`, and `}<inlineCode parentName="p">{`LAYOUT`}</inlineCode>{` system props.`}</p>
    <p>{`Read our `}<a parentName="p" {...{
        "href": "/system-props"
      }}>{`System Props`}</a>{` doc page for a full list of available props.`}</p>
    <h2>{`Component props`}</h2>
    <p><inlineCode parentName="p">{`Grid`}</inlineCode>{` does not get any additional props other than the system props mentioned above.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      